/*jshint esversion: 6 */
/*jshint sub:true*/
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  error: '',
  loading: false,
  subscribers: [],
  success: false
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getError: (state) => state.error,
  getSubscribers: (state) => state.subscribers,
  getSuccess: (state) => state.success,
  isLoading: ( state ) => state.loading
};
// Actions
const actions = {
  requestSubscribersForManagement({commit}) {
    return new Promise((resolve, reject) => {
      commit('set_loading', true);
      axios({
        url: 'subscribers',
        method: 'GET'
      })
      .then(resp => {
        commit('set_subscribers', resp.data.data);
        commit('set_loading', false);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
        reject();
      });
    });
  },
  subscribe({commit}, payload) {
    commit('set_loading', true);
    axios({
      url: 'subscribers',
      method: 'POST',
      data: payload
    })
    .then(resp => {
      commit('set_subscriber', resp.data.data);
      commit('set_success', true);
      commit('set_loading', false);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
      commit('set_loading', false);
    });
  }
};
// Mutations
const mutations = {
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_error(state, err){
    state.error = err;
  },
  set_loading(state, loading){
    state.loading = loading;
  },
  set_subscribers(state, subscribers){
    state.subscribers = [...subscribers];
  },
  set_subscriber(state, subscriber){
    state.subscriber = subscriber;
  },
  set_success(state, success){
    state.success = success;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
